const PaymentStatus = {
    INITIATED : 'INITIATED',
    SUBMISSION_FAILED : 'SUBMISSION FAILED',
    SUBMITTED : 'SUBMITTED',
    PAYMENT_FAILED : 'PAYMENT FAILED',
    PAID_NOT_RECEIPTED : 'PAID | NOT RECEIPTED',
    PAID_NO_TOKEN : 'PAID | NO TOKEN',
    RECEIPTED:'RECEIPTED',
    RECEIPT_DELIVERED:'RECEIPT DELIVERED',
}

export default PaymentStatus